/**
 * Area of operation code values. Only the ones that are needed for reference are
 * included in this file.
 */
export const AreaOfOperationCodes = {
    kmraAroundAFixedLocation: 'A',
    countywide: 'C',
    nationwide: 'N',
    other: 'O',
    kmraAroundACenterpoint: 'P',
    statewide: 'S',
    citywide: 'T',
    continentalUS: 'U',
    landMobileControlStation: 'X',
} as const;
